export default __webpack_public_path__ + "static/icon_sbas-04c49debf9523fe73e1a34ff687c5a1d.png";